import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";

const MyEvents = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";

  return (
    <div>
      <section
        className="py-5 bg-gradient d-flex align-items-center justify-content-center"
        style={{
          background: "linear-gradient(135deg, #fff6e5, #ffe8cc)",
        }}
        data-aos="zoom-in"
      >
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-8">
              <div className="bg-white p-5 shadow-lg rounded-4 border border-warning-subtle">
                <div className="display-4">🎉</div>
                <h2 className="fw-bold mt-3 mb-2 text-warning">
                  {t("comingSoon.title")}
                </h2>
                <p className="fs-5 text-muted">{t("comingSoon.description")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyEvents;
